import { render, staticRenderFns } from "./TheMainSidebar.vue?vue&type=template&id=f6d02b02&scoped=true&"
import script from "./TheMainSidebar.vue?vue&type=script&lang=js&"
export * from "./TheMainSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheMainSidebar.vue?vue&type=style&index=0&id=f6d02b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d02b02",
  null
  
)

export default component.exports